export const DEFAULT_ENGRAVINGS = {
  gold: {
    coeff1: 2,
    coeff2: 4,
    coeff3: 6,
    coeff4: 8,
    coeff5: 10,
    coeff6: 12,
    coeff7: 14,
  },
  white: {
    coeff1: 2,
    coeff2: 4,
    coeff3: 6,
    coeff4: 8,
    coeff5: 10,
    coeff6: 12,
    coeff7: 14,
  },
};

export const DEFAULT_COEFFICIENTS = {
  frenchEco: 2.3,
  frenchNormal: 2.3,
  importEco: 2.3,
  importNormal: 2.3,
  patterns: 2.3,
  accessories: 2.3,
  delivery: 2.3,
  coeffFr: 1,
  coeffImport: 1,
  coeffEcoImport: 1,
  coeffEcoFr: 1,
  engraving: DEFAULT_ENGRAVINGS,
};
